import { useState, useRef } from "react";
import MicNoneIcon from "@mui/icons-material/MicNone";
import MicIcon from "@mui/icons-material/Mic";
import { IconButton, Typography } from "@mui/material";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const RnDPage = () => {
  const [recording, setRecording] = useState(false);
  const [textOutput, setTextOutput] = useState("");
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [inputText, setInputText] = useState("");
  const [textGenerated, setTextGenerated] = useState("");
  const [testData, setTestData] = useState("");

  // const startRecording = async () => {
  //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //   const mediaRecorder = new MediaRecorder(stream);
  //   audioChunksRef.current = [];
  //   mediaRecorder.ondataavailable = (event) => {
  //     audioChunksRef.current.push(event.data);
  //   };
  //   mediaRecorder.onstop = () => {
  //     const blob = new Blob(audioChunksRef.current, { type: "audio/mp3" });
  //     uploadAudio(blob);
  //   };
  //   mediaRecorderRef.current = mediaRecorder;
  //   mediaRecorder.start();
  //   setRecording(true);
  // };

  // const stopRecording = () => {
  //   mediaRecorderRef.current.stop();
  //   setRecording(false);
  //   setTextOutput("Processing audio...");
  // };

  // const uploadAudio = async (blob) => {
  //   const formData = new FormData();
  //   formData.append("audio", blob, "audio.webm");
  //   const { data: voiceToTextData } = await openAiVoiceToTextLocalApi(formData);
  //   setTextOutput(voiceToTextData.text);

  //   const { data: generateData } = await ollamaVoiceToTextLocalApi({
  //     inputText: voiceToTextData.text,
  //     instruction: `chat::`,
  //   });
  //   // console.log("Generated Data:", JSON.parse(generateData.text));
  //   setTextGenerated(generateData.text);
  // };

  // const handleClick = async () => {
  //   const { data } = await ollamaVoiceToTextLocalApi({
  //     inputText,
  //     instruction: "generate direct details:",
  //   });
  //   setTextGenerated(data.text);
  // };
  // const handleChange = (e) => {
  //   setInputText(e.target.value);
  // };
  return (
    <>
      {/* <FlexBox>
        {recording ? (
          <IconButton onClick={stopRecording}>
            <MicIcon fontSize="large" />
          </IconButton>
        ) : (
          <IconButton onClick={startRecording}>
            <MicNoneIcon fontSize="large" />
          </IconButton>
        )}
      </FlexBox>
      <Typography>{textOutput}</Typography>
      <FlexBox>
        <input
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Type here..."
        />
        <input type="button" onClick={handleClick} value="Send" />
      </FlexBox>
      <Typography>{textGenerated}</Typography>

      <VoiceInputField /> */}
    </>
  );
};
